import type React from 'react'

import css from '../../styles.module.scss'
import type { ChartXLabel } from '../../useDailyUsageChart'

interface ChartXAxisProps {
  labels: ChartXLabel[]
  barCount: number
}

const barCenterPercent = (index: number, barCount: number): number =>
  ((index + 0.5) / barCount) * 100

export const ChartXAxis: React.FC<ChartXAxisProps> = ({ labels, barCount }) => (
  <div className={css.x_axis}>
    {labels.map((label) => (
      <span
        key={label.index}
        className={css.x_label}
        style={{ left: `${barCenterPercent(label.index, barCount)}%` }}
      >
        {label.label}
      </span>
    ))}
  </div>
)
